/**
 * Lectura del token CSRF para el patrón double-submit del backend.
 *
 * La auth de la API (feature #41) emite el JWT en cookies httpOnly y, junto a
 * ellas, una cookie CSRF **no httpOnly** que JS sí puede leer. El cliente la
 * reenvía en el header `X-CSRF-TOKEN`; flask-jwt-extended coteja ese header con
 * la cookie (config en `config.py`, `JWT_COOKIE_CSRF_PROTECT`).
 *
 * Nombres reales que dejó la #41 (defaults de flask-jwt-extended, verificados):
 * - cookie httpOnly del access token: `access_token_cookie` (JS no la ve).
 * - cookie CSRF legible por JS: `csrf_access_token`  <-- la que leemos aquí.
 * - header a reenviar: `X-CSRF-TOKEN`.
 */

/** Nombre de la cookie CSRF (no httpOnly) que emite el backend. */
export const CSRF_COOKIE_NAME = "csrf_access_token";

/** Nombre del header double-submit que espera el backend. */
export const CSRF_HEADER_NAME = "X-CSRF-TOKEN";

/**
 * Lee el valor de una cookie de `document.cookie` por nombre.
 *
 * Devuelve `null` si no existe o si no hay `document` (p. ej. SSR). El valor se
 * decodifica con `decodeURIComponent` porque el navegador codifica las cookies.
 */
export function readCookie(name: string): string | null {
  if (typeof document === "undefined" || !document.cookie) {
    return null;
  }
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const cookie = part.trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }
  return null;
}

/** Devuelve el token CSRF actual, o `null` si no hay sesión/cookie. */
export function readCsrfToken(): string | null {
  return readCookie(CSRF_COOKIE_NAME);
}
